import { startOfWeek, endOfWeek } from '../../../week'

export const currentWeek = day => day.isBetween(startOfWeek(), endOfWeek(), 'day', '[]')



// WEBPACK FOOTER //
// ./src/ui/navigate-by-week/views/helpers.jsx